import { apiClient } from "../../../lib";
import {
    GetActivitiesResponse,
    MaterialRequestDetails,
    MaterialRequestMutationResponse,
    MaterialRequestPayload,
    MaterialRequestQueryParams,
    MaterialRequestResponse,
} from "../types";

class MaterialReqService {

    async getMaterialReqs(params: MaterialRequestQueryParams): Promise<MaterialRequestResponse> {
         const searchParams = new URLSearchParams();
             Object.entries(params || {}).forEach(([key, value]) => {
                 if (Array.isArray(value)) {
                     value.forEach(v => {
                         if (v) searchParams.append(key, String(v));
                     });
                 } else if (value) {
                     searchParams.append(key, String(value));
                 }
             });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/material-request?${queryString}`);
        return response.data;
    };

    async getMaterialReqById({ projectId, requestId }: { projectId: string | undefined, requestId: string | null }): Promise<MaterialRequestDetails> {
        const response = await apiClient.get(`/material-request/${requestId}`);
        return response.data;
    };

    async createMaterialReq(data: MaterialRequestPayload): Promise<MaterialRequestMutationResponse> {
        const response = await apiClient.post("/material-request", data);
        return response.data;
    };

    async updateMaterialReq(id: string, data: MaterialRequestPayload): Promise<MaterialRequestMutationResponse> {
        const response = await apiClient.put(`/material-request/${id}`, data);
        return response.data;
    };

    async deleteMaterialReq(id: string): Promise<MaterialRequestMutationResponse> {
        const response = await apiClient.delete(`/material-request/${id}`);
        return response.data;
    };

    async getActivitys(projectId: string | undefined, phaseId: string): Promise<GetActivitiesResponse> {
        const response = await apiClient.get(`/projects/${projectId}/activities`, { params: { parent_id: phaseId } });
        return response.data;
    };

};

export const materialReqService = new MaterialReqService();
export default materialReqService;